import { SocialSignIn } from "@/components/auth/SocialSignIn.js";
import logo from "@rosette/assets/src/icons/google.svg";
import Image from "next/image";


interface GoogleSignInProps {
    redirectPathname: string | null;
}


export function GoogleSignIn({ redirectPathname }: GoogleSignInProps) {
    return (
        <SocialSignIn
            className="border-[#8e918f] bg-[#131314] hover:bg-[#262626] active:bg-[#131314]"
            provider="Google"
            redirectPathname={redirectPathname}>

            <Image className="mr-4 size-[1.5em]" src={logo} alt="Google Logo" />
            <span className="cursor-pointer font-medium text-[#e3e3e3] no-underline">
                Continue with Google
            </span>
        </SocialSignIn>
    );
}
